import { render, staticRenderFns } from "./ListDocumentCategories.vue?vue&type=template&id=265a97a9"
import script from "./ListDocumentCategories.vue?vue&type=script&lang=ts"
export * from "./ListDocumentCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports